module.exports = __webpack_public_path__ + "img/home-delivery.371bc163.jpeg";